var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-success purchase-exists-alert",domProps:{"innerHTML":_vm._s(_vm.textAlert)}})}
var staticRenderFns = []

export { render, staticRenderFns }